/* eslint-disable id-length */
import React from 'react';
import PropTypes from 'prop-types';
import { TradeRadioLoader } from './TradeRadioLoader';
import { Provider } from 'react-redux';

export const TradeRadioMiniPlayerProvider = ({ data = null, store = null }) => {
    return (
        <Provider store={store}>
            <TradeRadioLoader {...data} isMiniPlayer />
        </Provider>
    );
};

TradeRadioMiniPlayerProvider.propTypes = {
    store: PropTypes.object,
    data: PropTypes.shape({
        audioUrl: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        showImage: PropTypes.bool
    })
};
